import React, {PureComponent} from 'react';
import {InlineMessage} from '@homeaway/react-alerts';
import {FormattedMessage} from 'react-intl';

import {GENERIC_ERROR_MESSAGE} from '../../../utils/constants';

const GIFT_CARDS_ERROR_MESSAGE = (
    <FormattedMessage
        id="giftCardFormFailureMessage"
        defaultMessage={GENERIC_ERROR_MESSAGE}
    />
);

import {ERROR_MESSAGE_ID_TEXT} from '../../../utils/constants';
export default class GenericError extends PureComponent {
    render() {
        const {error} = this.props.meta;
        const errorText = (error && GIFT_CARDS_ERROR_MESSAGE) || '';
        return (
            <InlineMessage id={ERROR_MESSAGE_ID_TEXT} type="danger" message={errorText} marginBottom ={16} />
        );
    }
}
